import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { IconButton, Stack, Typography, useTheme } from '@mui/material';

import { regionalKnowledgeFilesTexts } from '../../../constants';

interface SelectedFilesPreviewProps {
    selectedFiles?: FileList | null;
    resetField: () => void;
}

export const SelectedFilesPreview = ({ selectedFiles, resetField }: SelectedFilesPreviewProps) => {
    const theme = useTheme();

    if (!selectedFiles || selectedFiles.length === 0) return null;

    const fileNames = Array.from(selectedFiles).map((file) => file.name);
    const text = fileNames.join(', ') + (fileNames.length > 0 ? '.' : '');

    return (
        <Stack alignItems='flex-start'>
            <Typography variant='body1'>
                {regionalKnowledgeFilesTexts.selectedFilesLabel}
            </Typography>
            <Stack direction='row' alignItems='center' flexWrap='wrap'>
                <Typography>{text}</Typography>
                <IconButton onClick={resetField}>
                    <DeleteRoundedIcon sx={{ color: theme.palette.customColors.orange }} />
                </IconButton>
            </Stack>
        </Stack>
    );
};
